import React from 'react';
import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function PhiBlockedNotice() {
  return (
    <div className="glp1-phi-block">
      <ExclamationCircleOutlined />
      <div>
        <Text strong>Please remove patient identifiers and resend.</Text>
        <p>
          We can't accept names, dates of birth, Medicare IDs, MRNs, addresses, phone or email, ZIP codes, or specific service dates. De-identified clinical facts are fine.
        </p>
        <div className="glp1-phi-examples" aria-label="Allowed de-identified examples">
          <span>BMI</span>
          <span>diagnosis category</span>
          <span>Part D status</span>
          <span>prior GLP-1 coverage</span>
        </div>
      </div>
    </div>
  );
}
